import { render, staticRenderFns } from "./FAQiOS.vue?vue&type=template&id=33b6fd29&scoped=true"
import script from "./FAQiOS.vue?vue&type=script&lang=js"
export * from "./FAQiOS.vue?vue&type=script&lang=js"
import style0 from "./FAQiOS.vue?vue&type=style&index=0&id=33b6fd29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b6fd29",
  null
  
)

export default component.exports